
<template>
  <div class="data-select">
    <!-- <input type="text" class="data-input" autocomplete="off" name="type-select" @focus="inputFocus" :value="selectedValue" > -->
    <p class="data-input" :class="{ on: listVisible, disabled:disabled }" name="type-select" @click="show" :value="selectedOption?.value" 
      >
      {{selectedOption?.label || placeholder}}
    </p>
    <datalist class="type-select" v-show="listVisible" @click="dataClick">
        <option v-for="{label, value, select}, index in options" :value="value" :data-select="select" :data-index="index">{{label}}</option>
        <!-- <slot></slot> -->
    </datalist>
  </div>
</template>

<script>
export default {
  name: 'MakeProcessSelector',
  props: {
    placeholder: String,
    options: {
      type: Array,
      default(){
        return []
      }
    },
    selected: {
      type: Number,
      default(){
        return 0
      }
    },
    disabled: {
      type: Boolean,
      default(){
        return false
      }
    },
    publicFlag: {
      type: Boolean,
      default(){
        return false
      }
    }
  },
  data() {
    return {
      itemList : [],
      listVisible : false,
      selectedText: '',
      selectedValue: '',
      selectedOption: {},
      selectItem: {},
    }
  },
  watch: {
    options (list) {
      this.selectCheck(list)
    },
    selected (value) {
      let index = 0
      if(value == 0){
        // value가 0인 경우 선택되지 않은 상태이기 때문에 -1을 넘기면 click event를 호출.
        this.dataClick(-1);
      }else {
        for (const item of this.options) {
          if (item.value === value) {
            this.dataClick(index)
            break
          }
          index++
        }
      }
    }
  },
  mounted() {
    this.selectCheck(this.options)
  },
  methods : {
    inputFocus(event) {
      if(this.listVisible){
        this.listVisible = false;
        return
      }
      this.listVisible = true;
    },
    dataClick (event) {
      const index = (typeof event === 'number') ? event : event.target.dataset.index
      if(!index){
        return;
      }
      const item = this.options[index]
      if(this.selectedOption) {
        this.selectedOption.select = false
      }
      if(event != -1) {
        item.select = true
        this.$emit('dataChange', {
          before : this.selectedOption,
          option : item,
          value : item.value
        })
      }
      this.selectedOption = item;
      this.listVisible = false;
    },
    selectCheck(list) {
      if(list && list.length > 0) {
        for(let item of list){
          if(item.select === true) {
            this.selectedOption = item;
            break;
          }
        }  
      }
    },
    show (e) {
      e.stopPropagation();
      if(this.publicFlag){
        window.alert("<b>이미 공개된 정보 입니다. <br>분류 또는 기술분류를 수정할 수 없습니다.<b/>");
      }
      if(this.disabled === true) return
      if(this.listVisible === true) {
        this.hide();
        return
      }
      this.listVisible = true;
      window.addEventListener('click', this.hide);
    },
    hide () {
      this.listVisible = false;
      window.removeEventListener('click', this.hide);
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-select {
    display: inline-flex; align-items: center;
    position: relative;
    padding: 0 10px 0 10px;
    font-size: 16px; 
    color: #333;

    .data-input {
      display: flex; align-items: center; justify-content: space-between; gap: 7px;
      box-sizing: border-box;
      min-width: 100%;
      border:0;
      font-size: 14px;
      cursor: pointer;
      &::after {
        content:'';
        display: inline-block;
        width: 12px; height: 12px;
        background: url('@/assets/icons/expand-more.svg') right center no-repeat;
      }
      &.on::after {
        transform: rotate(180deg);
      }
      &.disabled {
        &::after { content: none; display: none; }
      }
    }

    datalist {
      display: block;
      /*position: absolute; right: 0px; top: 100%;*/
      position: fixed; right: 0px; top: 0%; left: 100%;
      min-width: 100%;
      border: 1px solid rgba(153, 153, 153, 1);
      border-bottom-left-radius: 4px; border-bottom-right-radius: 4px;
      background: #fff;
      overflow: hidden;

      option {
        // min-width: 115px;
        min-width: 100%;
        padding: 10px 15px;
        font-size: 16px; font-weight: 500;
        cursor: pointer;
        &[data-select="true"] { color: rgba(0,0,0,.2)}
        &:hover {
          background-color: #eee
        }
      }
    }
  }
</style>

